import {Stack, styled} from '@mui/material'

export const WideFormField = styled(Stack)(() => ({
  width: '15rem',
}))

export const ModalContentWrapper = styled(Stack)(() => ({
  alignItems: 'center',
  gap: '2rem',
}))
